module.exports = "/fonts/vendor/summernote/dist/summernote.woff2?f694db69cded200e4edd999fddef81b7";